const params = {
  main: false,
  classes: {
    active: 'is-active',
    html: 'html-clip-body',
  },
};

const self = {};
self.lastScrollPosition = 0;
self.$element = false;
self.$html = document.documentElement;
self.$body = document.body;
self.$window = window;

self.setOpenClasses = () => {
  self.$element.classList.add(params.classes.active);
  self.$html.classList.add(params.classes.html);
};

self.removeOpenClasses = () => {
  self.$element.classList.remove(params.classes.active);
  self.$html.classList.remove(params.classes.html);
};

self.setOpenStyles = () => {
  let mobileNavHeight = self.$element.offsetHeight;
  const windowHeight = self.$window.innerHeight;
  if (mobileNavHeight < windowHeight) mobileNavHeight = windowHeight;

  self.$html.style.overflowX = 'hidden';
  self.$body.style.height = mobileNavHeight + 'px';
  self.$body.style.overflow = 'hidden';
  if (params.main) params.main.style.marginTop = self.lastScrollPosition * -1 + 'px';
};

self.removeOpenStyles = () => {
  self.$html.style.overflowX = '';
  self.$body.style.height = '';
  self.$body.style.overflow = '';
  if (params.main) params.main.style.marginTop = '';
};

const debounce = (func, wait) => {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
};

self.debouncedWindowResizeHandler = debounce(() => self.windowResizeHandler(), 400);

self.addEventListeners = () => self.$window.addEventListener('resize', self.debouncedWindowResizeHandler);
self.removeEventListeners = () => self.$window.removeEventListener('resize', self.debouncedWindowResizeHandler);

self.isActive = () => {
  if (!self.$element) return false;
  return window.getComputedStyle(self.$element).display !== 'none';
};

self.windowResizeHandler = () => {
  if (!self.isActive()) { self.closeMe(true); return; }
  self.setOpenStyles();
};

self.open = (element) => {
  self.$element = element;
  self.setOpenClasses();
  self.lastScrollPosition = self.$window.pageYOffset;
  self.setOpenStyles();
  self.addEventListeners();
  self.$window.scroll(0, 0);
};

self.closeMe = (element) => {
  if (!self.$element) self.$element = element;
  self.removeEventListeners();
  self.removeOpenClasses();
  self.removeOpenStyles();
  self.$window.scroll(0, self.lastScrollPosition);
};

self.toggle = (element) => {
  if (self.isActive()) self.closeMe(element);
  else self.open(element);
};

export default { open: self.open, close: self.closeMe, toggle: self.toggle, isActive: self.isActive, params };
